<template>
    <div class="animated fadeIn">
        <b-row v-if="Core.Validation.isId(dataBinder.id)">
            <b-col lg="6" sm="12">
                <h2>{{dataBinder.title}}</h2>
                <br/>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-tabs fill>
                    <b-tab @click="changeTab('tableOfContent')" :active="dataActiveTab === 'tableOfContent'" no-body v-if="Core.Validation.isId(dataId)">
                        <template slot="title">
                            {{Core.Definition.getDefinition('Tables des matières')}}
                        </template>
                        <TableOfContent
                                ref="tableOfContent"
                                :binderId="dataId"
                                class="mt-4"
                                @binderIndexOnClickFolder="binderIndexOnClickFolder"
                                @binderFormOnClickFolder="binderFormOnClickFolder">
                        </TableOfContent>
                    </b-tab>

                    <b-tab @click="changeTab('folder')" :active="dataActiveTab === 'folder'" no-body v-if="Core.Validation.isId(dataId)">
                        <template slot="title">
                            {{Core.Definition.getDefinition('Dossier')}}
                        </template>
                        <Folder
                                :binderId="dataId"
                                ref="folder"
                                class="mt-4">
                        </Folder>
                    </b-tab>

                    <b-tab @click="changeTab('PDF')" :active="dataActiveTab === 'PDF'"  v-if="Core.Validation.isId(dataId)">
                        <template slot="title">
                            {{Core.Definition.getDefinition('PDF')}}
                        </template>
                        <PDF
                                class="pdf-block"
                                ref="pdf"
                                :binderId="dataId">
                        </PDF>
                    </b-tab>

                    <b-tab  @click="changeTab('binder')">
                        <template slot="title">
                            {{dataBinderTemplate.singularTitle}}
                        </template>
                        <b-row class="mt-5">
                            <b-col>
                                <DynamicForm
                                        v-if="dataBinderTemplate !== false && Core.Validation.isId(dataBinderTemplate.id)"
                                        v-model="dataId"
                                        ref="dynamicFormBinderInstance"
                                        getRoot="/binder"
                                        saveRoot="/binder"
                                        @onInit="onInitBinderInstance"
                                        @onTrashClick="onTrashClickBinderInstance"
                                        @onRequestSuccess="onRequestSuccessBinderInstance"
                                        @onSaveSuccess="onSaveSuccess"
                                        :formStructure="dataBinder.formStructure">
                                </DynamicForm>
                                <ModalTrash
                                        ref="trash"
                                        root="/binder"
                                        @onTrashSuccess="onTrashSuccessBinderInstance"
                                        :caption="Core.Definition.getDefinition('Suppression')"
                                        :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cet enregistrement?')"></ModalTrash>
                            </b-col>
                        </b-row>
                        <b-row v-if="Core.Validation.isId(dataBinder.id)">
                            <b-col lg="6" sm="12">
                                <b-card>
                                    <table class="table table-borderless">
                                        <tr>
                                            <td>{{Core.Definition.getDefinition('Date de modification')}}</td>
                                            <td>{{Core.Date.readableDate(dataBinder.modificationDate)}}</td>
                                            <td>{{Core.Definition.getDefinition('Modifié par')}}</td>
                                            <td>{{dataBinder.modificationUser}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{Core.Definition.getDefinition('Date de création')}}</td>
                                            <td>{{Core.Date.readableDate(dataBinder.creationDate)}}</td>
                                            <td>{{Core.Definition.getDefinition('Créé par')}}</td>
                                            <td>{{dataBinder.creationUser}}</td>
                                        </tr>
                                    </table>
                                </b-card>
                            </b-col>
                        </b-row>
                    </b-tab>
                </b-tabs>
            </b-col>
        </b-row>

    </div>
</template>

<script>
    import DynamicForm from '../../../components/DynamicForm'
    import ModalTrash from '../../../components/ModalTrash'
    import TableOfContent from './TableOfContent'
    import Folder from './Folder'
    import PDF from './PDF'
    export default {
        name: 'BinderPanel',
        components: {
            DynamicForm,
            ModalTrash,
            TableOfContent,
            Folder,
            PDF
        },
        watch: {
            dataActiveTab(val) {
                switch(val) {
                    case 'folder':
                        this.$refs.folder.request(this.dataBinderIndexId, this.dataBinderFormId)
                        break
                    case 'tableOfContent':
                        this.$refs.tableOfContent.init()
                        break
                    case 'PDF':
                        this.$refs.pdf.init()
                        break
                }
            },
            dataSlug(val) {
                let binderTemplate = Core.Array.findByKey(Core.Session.binders, 'slug', val)
                if (binderTemplate) {
                    this.dataBinderTemplate = binderTemplate
                }
            }
        },
        mounted() {
            if (this.$route.params !== undefined) {
                if (this.$route.params.slug !== undefined) {
                    this.dataSlug = this.$route.params.slug
                }
            }
        },
        data: function () {
            return {
                Core: window.Core,
                dataId: '',
                dataSlug: '',
                dataBinderTemplate: false,
                dataBinderIndexId: '',
                dataBinderFormId: '',
                dataBinder: {
                    id: '',
                    title: '',
                    formStructure: {}
                },
                dataActiveTab: 'folder'
            }
        },
        methods: {
            changeTab(tab) {
                this.$refs.pdf.clear()
              this.dataActiveTab = tab
            },
            onInitBinderInstance() {
                this.$refs.dynamicFormBinderInstance.$refs.request.addArg('binderTemplateId', this.dataBinderTemplate.id)
            },
            onRequestSuccessBinderInstance(data) {
                if (data.binder !== undefined) {
                    this.dataBinder = data.binder
                }
            },
            onSaveSuccess() {
            },
            onTrashClickBinderInstance(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccessBinderInstance() {
                this.$router.push('/classeur/' + this.dataSlug)
            },
            binderIndexOnClickFolder(binderIndexId) {
                this.dataBinderIndexId = binderIndexId
                this.dataBinderFormId = ''
                this.dataActiveTab = 'folder'
            },
            binderFormOnClickFolder(binderIndexId, binderFormId) {
                this.dataBinderIndexId = binderIndexId
                this.dataBinderFormId = binderFormId
                this.dataActiveTab = 'folder'
            }
        }
    }
</script>
